import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/example/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/map',
          name: 'map',
          component: resolve => require(['@/view/map'], resolve),
          meta: {
            title: '地图'
          }
        },
        //关于我们
        {
          path: '/aboutUs/index',
          name: 'aboutUs',
          component: resolve => require(['@/view/aboutUs/index'], resolve),
          meta: {
            title: '关于我们 | 公司概要'
          },
        },
        {
          path: '/aboutUs/development',
          name: 'development',
          component: resolve => require(['@/view/aboutUs/development'], resolve),
          meta: {
            title: '关于我们 | 高质量发展'
          },
        },
        {
          path: '/aboutUs/culture',
          name: 'culture',
          component: resolve => require(['@/view/aboutUs/culture'], resolve),
          meta: {
            title: '关于我们 | 企业文化'
          },
        },
        {
          path: '/aboutUs/dynamics',
          name: 'dynamics',
          component: resolve => require(['@/view/aboutUs/dynamics'], resolve),
          meta: {
            title: '关于我们 | 新闻动态'
          },
        },
        {
          path: '/aboutUs/newsinfo/:id',
          name: 'newsinfo',
          component: resolve => require(['@/view/aboutUs/newsinfo'], resolve),
          meta: {
            title: '关于我们 | 新闻详情'
          },
        },

        //产品解决方案
        {
          path: '/solution/highSpeed',
          name: 'highSpeed',
          component: resolve => require(['@/view/solution/highSpeed'], resolve),
          meta: {
            title: '产品解决方案 | 超高层/超高速'
          },
        },
        {
          path: '/solution/officeScene',
          name: 'officeScene',
          component: resolve => require(['@/view/solution/officeScene'], resolve),
          meta: {
            title: '产品解决方案 | 办公场景'
          },
        },
        {
          path: '/solution/residence',
          name: 'residence',
          component: resolve => require(['@/view/solution/residence'], resolve),
          meta: {
            title: '产品解决方案 | 住宅场景'
          },
        },
        {
          path: '/solution/hotel',
          name: 'hotel',
          component: resolve => require(['@/view/solution/hotel'], resolve),
          meta: {
            title: '产品解决方案 | 酒店/商业'
          },
        },
        {
          path: '/solution/hospital',
          name: 'hospital',
          component: resolve => require(['@/view/solution/hospital'], resolve),
          meta: {
            title: '产品解决方案 | 医院场景'
          },
        },
        {
          path: '/solution/renovate',
          name: 'renovate',
          component: resolve => require(['@/view/solution/renovate'], resolve),
          meta: {
            title: '产品解决方案 | 更新改造'
          },
        },
        {
          path: '/solution/upgrade',
          name: 'upgrade',
          component: resolve => require(['@/view/solution/upgrade'], resolve),
          meta: {
            title: '产品解决方案 | 升级改造'
          },
        },
        {
          path: '/solution/factory',
          name: 'factory',
          component: resolve => require(['@/view/solution/factory'], resolve),
          meta: {
            title: '产品解决方案 | 原厂备件'
          },
        },
        {
          path: '/solution/guarantee',
          name: 'guarantee',
          component: resolve => require(['@/view/solution/guarantee'], resolve),
          meta: {
            title: '产品解决方案 | 运行保障'
          },
        },
        {
          path: '/solution/renew',
          name: 'renew',
          component: resolve => require(['@/view/solution/renew'], resolve),
          meta: {
            title: '产品解决方案 | 焕新升级'
          },
        },
        {
          path: '/solution/MAXIEZ-LZ',
          name: 'MAXIEZ-LZ',
          component: resolve => require(['@/view/solution/MAXIEZ-LZ'], resolve),
          meta: {
            title: '产品解决方案 | MAXIEZ-LZ(V)'
          },
        },
        {
          path: '/solution/decorate',
          name: 'decorate',
          component: resolve => require(['@/view/solution/decorate'], resolve),
          meta: {
            title: '产品解决方案 | 电梯装潢'
          },
        },
        {
          path: '/solution/machine/MAXIEZ-M/H',
          name: 'MAXIEZ-M/H',
          component: resolve => require(['@/view/solution/machine/MAXIEZ-M_H'], resolve),
          meta: {
            title: 'MAXIEZ-M/H'
          },
        },
        {
          path: '/solution/machine/MAXIEZ_LZ',
          name: 'MAXIEZ_LZ',
          component: resolve => require(['@/view/solution/machine/MAXIEZ_LZ'], resolve),
          meta: {
            title: 'MAXIEZ_LZ'
          },
        },
        {
          path: '/solution/machine/MAXIEZ_CZ',
          name: 'solution_MAXIEZ_CZ',
          component: resolve => require(['@/view/solution/machine/MAXIEZ_CZ'], resolve),
          meta: {
            title: 'MAXIEZ_CZ'
          },
        },
        {
          path: '/solution/machine/MAXIEZ_B',
          name: 'MAXIEZ_B',
          component: resolve => require(['@/view/solution/machine/MAXIEZ_B'], resolve),
          meta: {
            title: 'MAXIEZ_B'
          },
        },
        //国债补贴
        {
          path: '/nationalSupplement',
          name: 'NationalSupplement',
          component: resolve => require(['@/view/solution/nationalSupplement/index'], resolve),
          meta: {
            title: '国债补贴'
          },
          children: [
            {
              path: '/nationalSupplement',
              redirect: '/nationalSupplement/sh'
            },
            {
              path: '/nationalSupplement/sh',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/sh'], resolve),
              meta: {
                title: '国债补贴 | 上海'
              }
            },
            {
              path: '/nationalSupplement/bj',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/bj'], resolve),
              meta: {
                title: '国债补贴 | 北京'
              }
            },
            {
              path: '/nationalSupplement/hf',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/hf'], resolve),
              meta: {
                title: '国债补贴 | 合肥'
              }
            },
            {
              path: '/nationalSupplement/fz',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/fz'], resolve),
              meta: {
                title: '国债补贴 | 福州'
              }
            },
            {
              path: '/nationalSupplement/hk',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/hk'], resolve),
              meta: {
                title: '国债补贴 | 海口'
              }
            },
            {
              path: '/nationalSupplement/gd',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/gd'], resolve),
              meta: {
                title: '国债补贴 | 广东'
              }
            },
            {
              path: '/nationalSupplement/gz',
              name: 'nationalSupplement',
              component: resolve => require(['@/view/solution/nationalSupplement/gz'], resolve),
              meta: {
                title: '国债补贴 | 广州'
              }
            },
          ]
        },
        // 智慧服务
        {
          path: '/service/LNK',
          name: 'LNK',
          component: resolve => require(['@/view/service/LNK'], resolve),
          meta: {
            title: '智慧服务 | LNK智慧服务'
          }
        },
        {
          path: '/service/warranty',
          name: 'ensure',
          component: resolve => require(['@/view/service/warranty'], resolve),
          meta: {
            title: '智慧服务 | 十年质保'
          }
        },
        {
          path: '/service/CQS',
          name: 'CQS',
          component: resolve => require(['@/view/service/CQS'], resolve),
          meta: {
            title: '智慧服务 | CQS'
          }
        },
        {
          path: '/service/guarantee',
          name: 'guarantee',
          component: resolve => require(['@/view/service/guarantee'], resolve),
          meta: {
            title: '智慧服务 | 线上报修'
          }
        },

        // 经典项目
        {
          path: '/typicalprojects',
          name: 'typicalprojects',
          component: resolve => require(['@/view/typicalprojects/index'], resolve),
          meta: {
            title: '经典项目'
          },
        },
        {
          path: '/typicalprojects/case/:id',
          name: 'case',
          component: resolve => require(['@/view/typicalprojects/case'], resolve),
          meta: {
            title: '经典项目 | 案例'
          }
        },
        // 联系我们
        {
          path: '/contact/address',
          name: 'address',
          component: resolve => require(['@/view/contactUs/address'], resolve),
          meta: {
            title: '联系我们 | 公司地址'
          }
        },
        {
          path: '/contact/qutlets',
          name: 'qutlets',
          component: resolve => require(['@/view/contactUs/qutlets'], resolve),
          meta: {
            title: '联系我们 | 全国服务点'
          },
        },
        {
          path: '/contact/store',
          name: 'store',
          component: resolve => require(['@/view/contactUs/store'], resolve),
          meta: {
            title: '联系我们 | 体验中心'
          },
        },
        {
          path: '/contact/company',
          name: 'company',
          component: resolve => require(['@/view/contactUs/company'], resolve),
          meta: {
            title: '联系我们 | 直属分公司'
          },
        },
        {
          path: '/contact/family',
          name: 'family',
          component: resolve => require(['@/view/contactUs/family'], resolve),
          meta: {
            title: '联系我们 | 三菱大家庭'
          },
        },
        {
          path: '/contact/catalog',
          name: 'catalog',
          component: resolve => require(['@/view/contactUs/catalog'], resolve),
          meta: {
            title: '联系我们 | 产品手册'
          },
        },
        {
          path: '/contact/information',
          name: 'information',
          component: resolve => require(['@/view/contactUs/information'], resolve),
          meta: {
            title: '联系我们 | 随机资料'
          },
        },
        {
          path: '/contact/construction',
          name: 'construction',
          component: resolve => require(['@/view/contactUs/construction'], resolve),
          meta: {
            title: '联系我们 | 随机资料'
          },
        },
        {
          path: '/contact/notice',
          name: 'notice',
          component: resolve => require(['@/view/contactUs/notice'], resolve),
          meta: {
            title: '联系我们 | 信息告知'
          },
        },
        {
          path: '/5c3aa495f9544d9ab8bbccf4bda80878',
          name: 'MAXIEZ_BCZ',
          component: resolve => require(['@/view/contactUs/MAXIEZ_BCZ'], resolve),
          meta: {
            title: 'MAXIEZ_BCZ'
          },
        },
        {
          path: '/3d6ded93b69748c882bfb663e7a973d1',
          name: 'MAXIEZ_CZ',
          component: resolve => require(['@/view/contactUs/MAXIEZ_CZ'], resolve),
          meta: {
            title: 'MAXIEZ_CZ'
          },
        },
        {
          path: '/48a47efe48e347a58c0f8a77f5d4ae61',
          name: 'MAXIEZ_LZ_ZQX3',
          component: resolve => require(['@/view/contactUs/MAXIEZ_LZ_ZQX3'], resolve),
          meta: {
            title: 'MAXIEZ_LZ_ZQX3'
          },
        },
        {
          path: '/87fc6e09cb674f968e81ad4d783c03b3',
          name: 'MAXIEZ_LZ_ZQX4',
          component: resolve => require(['@/view/contactUs/MAXIEZ_LZ_ZQX4'], resolve),
          meta: {
            title: 'MAXIEZ_LZ_ZQX4'
          },
        },
        {
          path: '/4ebb79ceedd34c7b944aaba56c483a56',
          name: 'MAXIEZ_M',
          component: resolve => require(['@/view/contactUs/MAXIEZ_M'], resolve),
          meta: {
            title: 'MAXIEZ_M'
          },
        },
        {
          path: '/9740ff03709b474bbf3ce1394ae0464c',
          name: 'MAXIEZ_H',
          component: resolve => require(['@/view/contactUs/MAXIEZ_H'], resolve),
          meta: {
            title: 'MAXIEZ_H'
          },
        },
        //使用条款 隐私政策
        {
          path: '/terms',
          name: 'terms',
          component: resolve => require(['@/view/service/terms'], resolve),
          meta: {
            title: '相关服务 | 使用条款'
          }
        },
        {
          path: '/policy',
          name: 'policy',
          component: resolve => require(['@/view/service/policy'], resolve),
          meta: {
            title: '相关服务 | 个人信息保护政策'
          }
        },
        //海外版
        {
          path: '/en',
          redirect: '/en/home'
        },
        {
          path: '/en/home',
          name: 'en-home',
          component: resolve => require(['@/view/En/HomePage'], resolve),
          meta: {
            title: '海外首页'
          }
        },
        //关于我们
        {
          path: '/en/aboutUs/index',
          name: 'en_aboutUs',
          component: resolve => require(['@/view/En/aboutUs/index'], resolve),
          meta: {
            title: '关于我们 | 公司概要'
          },
        },
        {
          path: '/en/aboutUs/development',
          name: 'en_development',
          component: resolve => require(['@/view/En/aboutUs/development'], resolve),
          meta: {
            title: '关于我们 | 高质量发展'
          },
        },
        {
          path: '/en/aboutUs/culture',
          name: 'en_culture',
          component: resolve => require(['@/view/En/aboutUs/culture'], resolve),
          meta: {
            title: '关于我们 | 企业文化'
          },
        },
        {
          path: '/en/aboutUs/dynamics',
          name: 'en_dynamics',
          component: resolve => require(['@/view/En/aboutUs/dynamics'], resolve),
          meta: {
            title: '关于我们 | 新闻动态'
          },
        },
        {
          path: '/en/aboutUs/newsinfo/:id',
          name: 'en_newsinfo',
          component: resolve => require(['@/view/En/aboutUs/newsinfo'], resolve),
          meta: {
            title: '关于我们 | 新闻详情'
          },
        },
        //产品介绍
        {
          path: '/en/product/NexWay',
          name: 'NexWay',
          component: resolve => require(['@/view/En/product/NexWay'], resolve),
          meta: {
            title: '产品介绍 | NexWay'
          },
        },
        {
          path: '/en/product/NexWayS',
          name: 'NexWayS',
          component: resolve => require(['@/view/En/product/NexWayS'], resolve),
          meta: {
            title: '产品介绍 | NexWayS'
          },
        },
        {
          path: '/en/product/NEXIEZMRL',
          name: 'NEXIEZMRL',
          component: resolve => require(['@/view/En/product/NEXIEZMRL'], resolve),
          meta: {
            title: '产品介绍 | NEXIEZMRL'
          },
        },
        {
          path: '/en/product/CQS',
          name: 'en_CQS',
          component: resolve => require(['@/view/En/product/CQS'], resolve),
          meta: {
            title: '产品介绍 | CQS'
          },
        },
        // 经典项目
        {
          path: '/en/typicalprojects',
          name: 'en_typicalprojects',
          component: resolve => require(['@/view/En/typicalprojects/index'], resolve),
          meta: {
            title: '经典项目'
          },
        },
        {
          path: '/en/typicalprojects/case/:id',
          name: 'en_case',
          component: resolve => require(['@/view/En/typicalprojects/case'], resolve),
          meta: {
            title: '经典项目 | 案例'
          }
        },
        {
          path: '/en/contact/information',
          name: 'en_information',
          component: resolve => require(['@/view/En/contactUs/information'], resolve),
          meta: {
            title: '联系我们 | 公司信息'
          },
        },
        {
          path: '/en/contact/family',
          name: 'en_family',
          component: resolve => require(['@/view/En/contactUs/family'], resolve),
          meta: {
            title: '联系我们 | 三菱大家庭'
          },
        },
        {
          path: '/en/contact/download',
          name: 'download',
          component: resolve => require(['@/view/En/contactUs/download'], resolve),
          meta: {
            title: '联系我们 | 下载文件'
          },
        },
        {
          path: '/en/contact/inquiryform',
          name: 'inquiryform',
          component: resolve => require(['@/view/En/contactUs/inquiryform'], resolve),
          meta: {
            title: '联系我们 | 表单'
          },
        },
        {
          path: '/en/contact/construction',
          name: 'construction',
          component: resolve => require(['@/view/En/contactUs/construction'], resolve),
          meta: {
            title: '联系我们 | 随机资料'
          },
        },
        {
          path: '/en/terms',
          name: 'terms',
          component: resolve => require(['@/view/En/terms'], resolve),
          meta: {
            title: '相关服务 | 使用条款 | 海外'
          }
        },
        {
          path: '/en/policy',
          name: 'policy',
          component: resolve => require(['@/view/En/policy'], resolve),
          meta: {
            title: '相关服务 | 使用条款 | 海外'
          }
        },
        //第二部分
        //产品解决方案
        {
          path: '/en/solution/highSpeed',
          name: 'highSpeed',
          component: resolve => require(['@/view/En/solution/highSpeed'], resolve),
          meta: {
            title: '产品解决方案 | 超高层/超高速'
          },
        },
        {
          path: '/en/solution/officeScene',
          name: 'officeScene',
          component: resolve => require(['@/view/En/solution/officeScene'], resolve),
          meta: {
            title: '产品解决方案 | 办公场景'
          },
        },
        {
          path: '/en/solution/residence',
          name: 'residence',
          component: resolve => require(['@/view/En/solution/residence'], resolve),
          meta: {
            title: '产品解决方案 | 住宅场景'
          },
        },
        {
          path: '/en/solution/hotel',
          name: 'hotel',
          component: resolve => require(['@/view/En/solution/hotel'], resolve),
          meta: {
            title: '产品解决方案 | 酒店/商业'
          },
        },
        {
          path: '/en/solution/hospital',
          name: 'hospital',
          component: resolve => require(['@/view/En/solution/hospital'], resolve),
          meta: {
            title: '产品解决方案 | 医院场景'
          },
        },
        {
          path: '/en/solution/decorate',
          name: 'decorate',
          component: resolve => require(['@/view/En/solution/decorate'], resolve),
          meta: {
            title: '产品解决方案 | 电梯装潢'
          },
        },
      ]
    }
  ],
  mode: 'history',
  scrollBehavior: () => ({ y: 0 })
})

router.beforeEach((to, from, next) => {
  store.state.loading = true
  setTimeout(() => {
    next()
  }, 1000)
  setTimeout(() => {
    store.state.loading = false
  }, 3000);


})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js